<template>
  <div class="rizhiLookup">
    <!-- 日志查询 -->
    <el-card class="box-card" v-if="rizhiAuth.selectlogging">
      <div slot="header" class="clearfix header">
        <span class="card-header">操作日志查询</span>
      </div>
      <el-row>
        <el-form :inline="true" :model="handleForm" :label-position="labelPosition">
          <el-form-item label="模块">
            <el-input v-model.trim="handleForm.userModelOper"></el-input>
          </el-form-item>
          <el-form-item label="状态">
            <el-select placeholder="请选择" clearable v-model="handleForm.status">
              <el-option
                v-for="item in statusList"
                :key="item.value"
                :label="item.label"
                :value="item.value"/>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="success" @click="queryFrom()">查询</el-button>
            <el-button type="danger" @click="clearForm()">重置</el-button>
          </el-form-item>
        </el-form>
      </el-row>
    </el-card>

    <el-card class="box-card">
      <div slot="header" class="clearfix header">
        <span class="card-header">日志信息</span>
      </div>
      <!--列表-->
      <el-row :gutter="2">
        <el-col :xs="10">
          <el-table :data="configureInfo" style="width: 100%;" border :fit="true"
                    :header-cell-style="{'text-align':'center'}">
            <el-table-column prop="userName" label="操作人" sortable resizable :show-overflow-tooltip="true"
                             align="center"></el-table-column>
            <el-table-column prop="userModelOper" label="操作模块" sortable resizable :show-overflow-tooltip="true"
                             align="center"></el-table-column>
            <el-table-column prop="userOperType" label="用户操作" sortable resizable :show-overflow-tooltip="true"
                             align="center"></el-table-column>
            <el-table-column prop="requestUrl" label="请求url" sortable resizable :show-overflow-tooltip="true"
                             align="center"></el-table-column>
            <el-table-column prop="requestType" label="请求方式" sortable resizable :show-overflow-tooltip="true"
                             align="center"></el-table-column>
            <el-table-column prop="requestParam" label="请求参数" sortable resizable :show-overflow-tooltip="true"
                             align="center"></el-table-column>
            <el-table-column prop="status" label="状态" sortable resizable :show-overflow-tooltip="true" align="center">
              <template slot-scope="scope">
                <el-tag
                  :type="scope.row.status === 'success' ? 'success' : 'danger'"
                  disable-transitions>{{scope.row.status}}
                </el-tag>
              </template>
            </el-table-column>
            <el-table-column prop="requestIp" label="请求ip" sortable resizable :show-overflow-tooltip="true"
                             align="center"></el-table-column>
            <el-table-column prop="requestUserAgent" label="user-agent" sortable resizable :show-overflow-tooltip="true"
                             align="center"></el-table-column>
            <el-table-column prop="createTime" label="创建时间" :formatter="resolvingDate" sortable resizable
                             :show-overflow-tooltip="true"
                             align="center"></el-table-column>
          </el-table>
          <!--工具条-->
          <el-pagination align='left'
                         @size-change="handleSizeChange"
                         @current-change="handleCurrentChange"
                         :current-page="pages.page"
                         :page-sizes="[10, 20, 50, 100]"
                         :page-size="pages.pageSize"
                         layout="total, sizes, prev, pager, next, jumper"
                         :total="pages.total">
          </el-pagination>
        </el-col>
      </el-row>
    </el-card>
  </div>
</template>
<script>
  let moment = require("moment");
  import {selectLogs} from '../../api/api'
  import {getPermission} from '../../api/authRequest'

  export default {
    data() {
      return {
        labelPosition: 'left',
        handleForm: {
          oper_user: '',
          oper_ip: '',
          timeStart: '',
          timeEnd: ''
        },
        dialogTableVisible: false,
        configureInfo: [],
        pages: {
          page: 1,
          pageSize: 10,
          total: 0

        },
        rizhiAuth: {
          selectlogging: false,
        },
        statusList: [{
          value: "success",
          label: "成功"
        },
          {
            value: 'fail',
            label: "失败"
          },
          {
            value: "error",
            label: "错误"
          }
        ]
      }
    },
    mounted() {
      this.selectlogging()
      this.rizhiAuth.selectlogging = getPermission('/system/logging/selectlogging');
    },
    methods: {
      filterTag(value, row) {
        return row.tag === value;
      },
      //获取用户日志
      selectlogging() {
        let para = {
          userModelOper: this.handleForm.userModelOper,
          status: this.handleForm.status,
          pageSize: this.pages.pageSize,
          startRow: this.pages.page,
        };
        selectLogs(para).then((res) => {
          if (res.data.status == 100) {
            this.configureInfo = res.data.results.list;
            this.pages.total = res.data.results.total;
          }
        }).catch((error) => {
          this.$Message.error(error.message);
        })
      },
      //重置
      clearForm: function () {
        this.handleForm = {}
      },
      //查询
      queryFrom: function () {
        this.selectlogging()
      },
      handleSizeChange(val) {
        this.pages.pageSize = val
        this.selectlogging()
      },
      handleCurrentChange(Page) {
        this.pages.page = Page
        this.selectlogging()
      },
      /*时间格式化*/
      resolvingDate:function (row,column) {
        if (!row.createTime){
          return "";
        }
        let  d=new Date(row.createTime);
        let month = (d.getMonth() + 1) < 10 ? '0'+(d.getMonth() + 1) : (d.getMonth() + 1);
        let day = d.getDate()<10 ? '0'+d.getDate() : d.getDate();
        let hours = d.getHours()<10 ? '0'+d.getHours() : d.getHours();
        let min = d.getMinutes()<10 ? '0'+d.getMinutes() : d.getMinutes();
        let sec = d.getSeconds()<10 ? '0'+d.getSeconds() : d.getSeconds();

        let times=d.getFullYear() + '-' + month + '-' + day + ' ' + hours + ':' + min + ':' + sec;
        return times;
      }
    },
  }
</script>

<style lang="scss" scoped>
  .rizhiLookup {
    .box-card {
      margin-bottom: 20px;
      border-radius: 0px;

      /*.header{background-color: #f5f5f5}*/
      .card-header {
        font-size: 14px;
        line-height: 0px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// rizhiLookup.vue?5f240952